import { render } from "./reimprimirMenu.vue?vue&type=template&id=d5cf7b96"
import script from "./reimprimirMenu.vue?vue&type=script&lang=js"
export * from "./reimprimirMenu.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__